export default __webpack_public_path__ + "static/media/Vector (2).d678f31f.svg";